module.exports = __webpack_public_path__ + "static/media/footstep.1ad0173c.mp3";